import React from "react";

const CopyrightsPanel = () => {
  return (
    <div className="copyrightContainer">
      <div className="outerCircle">
        <div className="middleCircle">
          <div className="innerCircle" />
        </div>
      </div>
      <div className="copyrightInfo">
        <span>Copyrights &copy; 2023. All rights reserved.</span>
        <br />
        <span>Designed & Developed by &#128151; Adeesha Mahalekam</span>
      </div>
    </div>
  );
};

export default CopyrightsPanel;
